<!-- track alto: gera a distância de scroll que dirige a entrada no iglu -->
<section class="igloo-hero" [class.landscape]="mode === 'landscape'" id="igloo">
  <div class="igloo-sticky">
    <canvas #canvas class="igloo-canvas"></canvas>

    <!-- Texto central (só no modo full) -->
    <div class="igloo-hero-content" #content *ngIf="mode === 'full'">
      <h1><span class="hl">Apps</span> e <span class="hl">Sites</span> que vendem de verdade</h1>
      <p>Do conceito ao lançamento, feitos pra <strong>converter</strong>.</p>
    </div>

    <!-- Marca + copyright no canto superior esquerdo (só no modo full) -->
    <div class="igloo-brand" #brand *ngIf="mode === 'full'">
      <h2 class="igloo-logo">IGLOOCODE</h2>
      <p class="igloo-copy">// Direito Autoral &copy; {{ year }}</p>
      <p class="igloo-copy">IglooCode<br>Todos os direitos reservados.</p>
    </div>

    <!-- Conteúdo projetado (modo paisagem: ex. "Quem Somos") -->
    <div class="igloo-hero-content" *ngIf="mode === 'landscape'">
      <ng-content></ng-content>
    </div>

    <!-- Produtos: surgem na fase final do scroll, por cima da paisagem fixa (mesma seção) -->
    <div class="hero-products" #cards *ngIf="mode === 'full'">
      <div class="hp-head">
        <p class="hp-kicker">////// O que entregamos</p>
        <h2 class="hp-heading">Nossos <span class="hl">produtos</span></h2>
      </div>
      <div class="hp-track" #cardsTrack>
        <article class="hp-panel" *ngFor="let pr of products">
          <!-- Ondas cinzas decorativas ao fundo do card -->
          <svg class="hp-waves" viewBox="0 0 600 420" preserveAspectRatio="none" aria-hidden="true">
            <path fill="#eef2f6" d="M0,250 C140,205 300,300 460,255 C540,232 580,250 600,245 L600,420 L0,420 Z"/>
            <path fill="#e0e7ee" d="M0,300 C160,258 340,348 520,300 C565,288 588,300 600,296 L600,420 L0,420 Z"/>
            <path fill="#cfd9e2" d="M0,348 C150,315 360,378 540,342 C572,336 590,344 600,342 L600,420 L0,420 Z"/>
            <path fill="#bcc8d3" d="M0,388 C170,362 380,406 560,382 C580,379 592,384 600,383 L600,420 L0,420 Z"/>
          </svg>
          <span class="hp-num">{{ pr.n }}</span>
          <div class="hp-body">
            <h3 class="hp-title">{{ pr.title }}</h3>
            <p class="hp-desc">{{ pr.desc }}</p>
          </div>
          <a class="hp-cta" [routerLink]="['/servicos']" [fragment]="pr.fragment">Ver mais &rarr;</a>
        </article>
      </div>
      <p class="hp-hint">role para explorar &rarr;</p>
    </div>

    <!-- CTA final: surge enquanto a câmera faz o pan para a direita da paisagem -->
    <div class="hero-cta" #cta *ngIf="mode === 'full'">
      <div class="hc-inner">
        <p class="hc-kicker">////// Bora começar?</p>
        <h2 class="hc-heading">Vamos tirar a sua ideia do <span class="hl">papel</span></h2>
        <p class="hc-text">Conte o que você precisa e receba uma proposta personalizada — sem compromisso.</p>
        <a class="hc-btn" href="https://wa.me/5548988527818?text=Olá!%20Gostaria%20de%20realizar%20um%20orçamento%20para%20a%20criação%20de%20uma%20página%20web" target="_blank" rel="noopener">Falar no WhatsApp &rarr;</a>
      </div>
    </div>

    <div class="scroll-arrow igloo-scroll" #scrollHint *ngIf="mode === 'full'">

    </div>

    <!-- Overlay da nevasca / whiteout no fim do scroll (só no modo full) -->
    <div class="blizzard-overlay" #blizzard *ngIf="mode === 'full'"></div>
  </div>
</section>
